import { MessageCircle } from 'lucide-react';
import { toast } from 'sonner';
import { openMessage } from '../../lib/whatsapp';

// Küçük yeşil WhatsApp butonu; tıklayınca hazır mesajla WhatsApp açılır
export const WhatsAppButton = ({ phone, text, label = 'WhatsApp', testId, className = '', compact = false }) => {
  const onClick = (e) => {
    e.stopPropagation();
    try { openMessage('whatsapp', phone, typeof text === 'function' ? text() : text); }
    catch (err) { toast.error(err.message); }
  };
  return (
    <button type="button" onClick={onClick} data-testid={testId} title={label}
      className={`inline-flex items-center gap-1.5 rounded-lg bg-[#25D366] hover:bg-[#1ebe5b] text-white font-semibold transition-colors ${compact ? 'p-1.5' : 'px-3 py-1.5 text-xs'} ${className}`}>
      <MessageCircle className={compact ? 'h-4 w-4' : 'h-3.5 w-3.5'} />
      {!compact && label}
    </button>
  );
};
